import Grid from '@mui/joy/Grid'
import React, {useEffect, useState} from 'react'
import PunchCard from './PunchCard'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import Typography from '@mui/joy/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import {Container, Snackbar} from '@mui/joy'
import {useAddStampMutation, useGetMyStampsQuery} from '../services/stamps'
import {useGetStoreByIdQuery} from '../services/stores'

function StoreCard() {
  const [lastStamp, setLastStamp] = useState(-1)
  const [getMyStampsQueryLimit, setGetMyStampsQueryLimit] = useState<number>(21)
  const [earned, setEarned] = useState<boolean>(false)

  const [addStamp, {isError: addStampError, isLoading: isAddStampLoading}] = useAddStampMutation({
    fixedCacheKey: 'shared-delete-reward',
  })
  const [isAddStampError, setIsAddStampError] = useState(addStampError)

  const {id: storeId} = useParams() as { id: string }
  const navigate = useNavigate()

  const {data: store} = useGetStoreByIdQuery(storeId)

  const location = useLocation();
  const query = React.useMemo(() => new URLSearchParams(location.search), [location.search]);
  const otpQuery = query.get('otp')

  const {isLoading: isGetMyStampsLoading} = useGetMyStampsQuery(
    {storeId: store?.id ?? '', limit: store?.numberOfStamps ?? 10},
    {
      skip: store?.numberOfStamps === 21,
    },
  )

  function goTo(route: string) {
    navigate(route)
  }

  useEffect(() => {
    setIsAddStampError(addStampError)
  }, [addStampError])

  useEffect(() => {
    if (store) {
      setGetMyStampsQueryLimit(store.numberOfStamps)
    }
  }, [store])

  // useEffect(() => {
  //   const numberOfSt = store?.numberOfStamps ?? 0
  //
  //   if (myStamps) {
  //     if (myStamps.length % numberOfSt == 0) {
  //       setTimeout(() => setLastStamp(0), 1000)
  //     } else {
  //       setLastStamp(myStamps.length - 1)
  //     }
  //   }
  // }, [myStamps, otpQuery, store])

  useEffect(() => {
    console.log("otpQuery")
    console.log(otpQuery)

    console.log("isAddStampLoading")
    console.log(isAddStampLoading)

    if (otpQuery && !isAddStampLoading) {
      addStamp({storeId: storeId, otp: otpQuery})

      if (addStampError === undefined) {
        setLastStamp(lastStamp + 1)

        if (store?.numberOfStamps === lastStamp) {
          setEarned(true)
        }
      }
    }
  }, [otpQuery])

  // if (isAddStampLoading || !store) {
  //   return (
  //     <Container>
  //       <Grid
  //         container
  //         justifyContent="center"
  //         alignItems="center"
  //         direction="column"
  //       >
  //         <CircularProgress/>
  //       </Grid>
  //     </Container>
  //   )
  // }

  function goToRewards() {
    goTo(`/${storeId}/rewards`)
  }

  return (
    <>
      <Snackbar
        autoHideDuration={3000}
        variant="soft"
        color="danger"
        open={isAddStampError && otpQuery !== null}
        onClose={() => setIsAddStampError(false)}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
      >
        Hiba történt!
      </Snackbar>
      <Container>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid sx={{pb: 2, pt: 2}}>
            <Typography
              level="h4"
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
              onClick={() => goTo('/')}
            >
              <ArrowBackIcon/>
              Vissza az üzleteimhez
            </Typography>
          </Grid>
          <PunchCard lastStamp={lastStamp}/>
        </Grid>
      </Container>
    </>
  )
}

export default StoreCard
